import React from "react";
import styles from "./ChatUsPage.module.scss";

import GradientImage from "./assets/gradients.png";
import NewHeader from "./components/NewHeader/NewHeader";
import WidgetBtn from "./components/WidgetBtn/WidgetBtn";

import ChatIcon from "./assets/chat.svg";
import CallIcon from "./assets/call.svg";
import Cities from "./components/Citites/Citites";
import NewFooter from "./components/NewFooter/NewFooter";

import OkIcon from "./assets/ok.svg";
import TgIcon from "./assets/tg.svg";
import VkIcon from "./assets/vk.svg";
import MaxIcon from "./assets/max.svg";

const ChatUsPage = () => {
  return (
    <div className={styles.chatUs}>
      {/* main section */}
      <div
        className={styles.sectionMain}
        style={{ "--bg-image": `url(${GradientImage})` } as any}
      >
        <div className={styles.container}>
          <NewHeader />

          <div className={styles.widgetBtns}>
            <div className={styles.btn}>
              <WidgetBtn
                widgetId={"019f3757-a1dc-7f70-aa97-52553399281d"}
                text="Написать в чат"
                btnIcon={ChatIcon}
              />
            </div>

            <div className={styles.btn}>
              <WidgetBtn
                widgetId={"019f377a-5ecc-71ef-b658-6d1ef4ecc7aa"}
                text="Видео-звонок"
                btnIcon={CallIcon}
              />
            </div>
          </div>

          <p className={styles.text}>
            На линии специалисты, готовые ответить на ваш вопрос
          </p>
        </div>
      </div>

      {/* second section  */}
      <div className={styles.section}>
        <div className={styles.container}>
          {/* socials */}
          <h1 className={styles.socialsTitle}>
            Наши <span>социальные сети</span>
          </h1>

          <p className={styles.desc}>
            Следите за нашими новостями, акциями и закулисьем компании
          </p>

          <div className={styles.icons}>
            <a href="#" className={styles.link}>
              <img src={OkIcon} alt="" className={styles.icon} />
            </a>

            <a href="#" className={styles.link}>
              <img src={MaxIcon} alt="" className={styles.icon} />
            </a>

            <a href="https://vk.ru/cv_saby_pro" className={styles.link}>
              <img src={VkIcon} alt="" className={styles.icon} />
            </a>

            <a href="#" className={styles.link}>
              <img src={TgIcon} alt="" className={styles.icon} />
            </a>
          </div>

          <div className={styles.title}>
            <div className={styles.left}>Всегда на связи</div>
            <div className={styles.right}>Адреса и контакты</div>
          </div>

          <div className={styles.cities}>
            <Cities></Cities>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <NewFooter />
      </div>
    </div>
  );
};

export default ChatUsPage;
